module.exports = __webpack_public_path__ + "img/q.acc803dd.jpg";